import { highlightText } from "@/shared/lib";

export const smartTruncateAroundQuery = (text = "", query = "", width = 0) => {
  if (!text || !query || width <= 0) return text;

  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();
  const index = lowerText.indexOf(lowerQuery);
  if (index === -1) return text;

  const avgCharWidth = 8;
  const maxVisibleChars = Math.floor(width / avgCharWidth);

  const queryLength = query.length;
  const totalTextLength = text.length;

  if (totalTextLength <= maxVisibleChars) return highlightText(text, query);

  const remainingSpace = maxVisibleChars - queryLength;
  const beforeCount = Math.floor(remainingSpace / 2);

  let start = Math.max(0, index - beforeCount);
  let end = start + maxVisibleChars;

  if (end > totalTextLength) {
    end = totalTextLength;
    start = Math.max(0, end - maxVisibleChars);
  }

  let result = text.slice(start, end);

  if (start > 0) result = "..." + result;
//   if (end < totalTextLength) result += "...";

  return highlightText(result, query);
};